__webpack_require__.p = "https://sto-stage.baza.education/packs/";